import type { ReactNode } from "react";

export function formatValue(value: unknown): ReactNode {
  if (
    value === null ||
    value === undefined ||
    (typeof value === "string" && value.trim() === "")
  ) {
    return "-";
  }

  if (value instanceof Date) {
    return value.toLocaleDateString();
  }

  return value as ReactNode;
}